/** Admin preference: show member home instead of admin dashboard. */
export const DASHBOARD_PREVIEW_MEMBER_KEY = "praisify.dashboardPreviewMember";

export function getPreviewMemberHome(): boolean {
  try {
    const stored = localStorage.getItem(DASHBOARD_PREVIEW_MEMBER_KEY);
    if (stored === "1" || stored === "0") return stored === "1";
    // Migrate older sessionStorage preference from the dashboard banner
    const legacy = sessionStorage.getItem(DASHBOARD_PREVIEW_MEMBER_KEY);
    if (legacy === "1") {
      localStorage.setItem(DASHBOARD_PREVIEW_MEMBER_KEY, "1");
      return true;
    }
  } catch {
    /* ignore */
  }
  return false;
}

export function setPreviewMemberHome(enabled: boolean): void {
  try {
    localStorage.setItem(DASHBOARD_PREVIEW_MEMBER_KEY, enabled ? "1" : "0");
  } catch {
    // ignore
  }
  window.dispatchEvent(
    new CustomEvent("praisify:dashboard-view-pref", { detail: { enabled } }),
  );
}
